<div class="admin-pricing core-screen">
  <div class="title-bar">
    <div class="title-section">
      @if (!embeddedInCabinetPage()) {
        <h1 class="core-title">
          {{ 'admin.pricing.domains.' + domain() + '.title' | translate }}
        </h1>
      }
      @if (!embeddedInCabinetPage() && displayCount() !== null) {
        <span class="count">{{ displayCount() }}</span>
      }
    </div>
    @if (initialized()) {
      <button type="button" class="add-button" (click)="onCreate()">
        +
        {{
          'admin.pricing.domains.' + domain() + '.createAction' | translate
        }}
      </button>
    }
  </div>

  @if (initialized() && timelineSegments().length > 0) {
    <div class="timeline-rail" aria-hidden="true">
      @for (segment of timelineSegments(); track segment.version.id) {
        <div
          class="timeline-segment"
          [class.timeline-segment--current]="isCurrent(segment.version)"
          [class.timeline-segment--future]="isFuture(segment.version)"
        ></div>
      }
    </div>
  }

  <div class="versions-list">
    @if (versions().length > 0) {
      @for (version of versions(); track version.id) {
        <a
          class="version-card"
          [class.version-card--current]="isCurrent(version)"
          [class.version-card--future]="isFuture(version)"
          [routerLink]="versionLink(version.id)"
        >
          <div class="version-card__header">
            <div class="version-badge">v{{ version.version_number }}</div>
            <div class="version-meta">
              <div class="version-dates">
                {{ 'admin.pricing.effectiveFrom' | translate }}:
                {{ formatDate(version.effective_from) }}
                @if (version.effective_to) {
                  <span class="separator">·</span>
                  {{ 'admin.pricing.effectiveTo' | translate }}:
                  {{ formatDate(version.effective_to) }}
                } @else {
                  <span class="separator">·</span>
                  {{ 'admin.pricing.effectiveOpen' | translate }}
                }
              </div>
              @if (domain() === 'storage') {
                <div class="version-rate">
                  {{ 'admin.pricing.baseRate' | translate }}:
                  {{ formatRate(version.base_rate_bynd_per_m3_day) }}
                  {{ 'admin.pricing.rateUnit' | translate }}
                </div>
              } @else if (domain() === 'promocodes') {
                <div class="version-rate">
                  {{ 'admin.pricing.promocodeCount' | translate }}:
                  {{ version.promocode_count ?? 0 }}
                </div>
              }
              @if (version.comment) {
                <div class="version-comment">{{ version.comment }}</div>
              }
            </div>
            <div class="version-status">
              @if (isFuture(version)) {
                <span class="status-badge status-badge--future">
                  {{ 'admin.pricing.statusFuture' | translate }}
                </span>
              } @else if (isCurrent(version)) {
                <span class="status-badge status-badge--current">
                  {{ 'admin.pricing.statusCurrent' | translate }}
                </span>
              }
            </div>
          </div>
        </a>
      }
    } @else if (loadError()) {
      <p class="hint hint--error" role="alert">
        {{ 'admin.pricing.loadError' | translate }}
      </p>
    } @else if (!loading() && initialized()) {
      <div class="pricing-empty-state">
        <span>&nbsp;</span>
        <div class="empty-block">
          <img src="/icons/employees-empty.svg" alt="" />
          <p class="empty-text">
            {{
              'admin.pricing.domains.' + domain() + '.empty' | translate
            }}
          </p>
          <p class="empty-hint">
            {{
              'admin.pricing.domains.' + domain() + '.emptyHint' | translate
            }}
          </p>
        </div>
        <lib-cabinet-button
          class="empty-button"
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="
            'admin.pricing.domains.' + domain() + '.createAction' | translate
          "
          [action]="{ type: 'action' }"
          (actionEvent)="onCreate()"
        />
      </div>
    } @else if (loading()) {
      <p class="hint" role="status">
        {{ 'admin.staffQrScan.loading' | translate }}
      </p>
    }
  </div>
</div>
